import { Suspense, useMemo } from "react"
import { createFileRoute } from "@tanstack/react-router"
import { EmptyState, Skeleton } from "toptaal-shared"
import { useTodosQuery } from "@/api/queries/todo/useTodosQuery"
import { TodoDetail } from "@/components/todo/TodoDetail"

export const Route = createFileRoute("/todo/$category/$todoId/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { category, todoId } = Route.useParams()
  const { data: todos } = useTodosQuery()

  const todo = useMemo(() => {
    const items = todos?.[category as keyof typeof todos] ?? []

    return items.find((item) => String(item.id) === String(todoId))
  }, [todos, category, todoId])

  if (!todo) {
    return (
      <div className="flex items-center justify-center h-full">
        <EmptyState className="!font-domine">Geen taak gevonden</EmptyState>
      </div>
    )
  }

  return (
    <Suspense
      fallback={
        <div className="max-w-4xl mx-auto p-8 w-full">
          <Skeleton className="h-8 w-1/2 mb-4" />
          <Skeleton className="h-4 w-full mb-2" />
          <Skeleton className="h-4 w-5/6 mb-6" />
          <Skeleton className="h-20 w-full mb-6" />
          <Skeleton className="h-10 w-32" />
        </div>
      }
    >
      <TodoDetail todo={todo} />
    </Suspense>
  )
}
